import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

  @Input() color = '#ffffff';

  public styleColor() {
    return {
      'border': `8px solid ${this.color}`,
      'border-color': `${this.color} transparent transparent transparent`
  };
}

}



// WEBPACK FOOTER //
// ./src/app/components/loading/loading.component.ts